module.exports = __webpack_public_path__ + "static/oncologica-e1909eada2800d8be57e6d3d923923c5.png";